import myTrainingIntro from "./my-training-intro.md?raw";
import coursesIntro from "./courses-intro.md?raw";

// The site's editable content sections, addressed by a stable id.
//
// Today each section is authored as a markdown file in src/content/ and bundled
// at build. The id-based indirection is deliberate and load-bearing: when we add
// admin-page editing later, ONLY this registry (and ContentSection's resolver)
// swaps to a KV/API source — every consumer (`<ContentSection id="…" />`) stays
// unchanged. To add a section: drop a `<id>.md` in this folder and register it
// here. The keys are the contract.
export const contentSections = {
  "my-training-intro": myTrainingIntro,
  "courses-intro": coursesIntro
} as const;

export type ContentSectionId = keyof typeof contentSections;
